export const GET_SCALES_REQUEST = 'GET_SCALES_REQUEST';
export const GET_SCALES_SUCCESS = 'GET_SCALES_SUCCESS';
export const GET_SCALES_FAILED = 'GET_SCALES_FAILED';

export const RESET_SCALES = 'RESET_SCALES';

export const GET_SCALE_REQUEST = 'GET_SCALE_REQUEST';
export const GET_SCALE_SUCCESS = 'GET_SCALE_SUCCESS';
export const GET_SCALE_FAILED = 'GET_SCALE_FAILED';

export const ADD_SCALE_REQUEST = 'ADD_SCALE_REQUEST';
export const ADD_SCALE_SUCCESS = 'ADD_SCALE_SUCCESS';
export const ADD_SCALE_FAILED = 'ADD_SCALE_FAILED';

export const EDIT_SCALE_REQUEST = 'EDIT_SCALE_REQUEST';
export const EDIT_SCALE_SUCCESS = 'EDIT_SCALE_SUCCESS';
export const EDIT_SCALE_FAILED = 'EDIT_SCALE_FAILED';

export const DELETE_SCALE_REQUEST = 'DELETE_SCALE_REQUEST';
export const DELETE_SCALE_SUCCESS = 'DELETE_SCALE_SUCCESS';
export const DELETE_SCALE_FAILED = 'DELETE_SCALE_FAILED';
